/**
 * Landing Layout
 *
 * Layout for marketing/landing pages (HomePage).
 * Features: AppHeader (navigation) + Content + Footer
 */

import { ReactNode } from "react";
import { AppHeader } from "./AppHeader";
import { Footer } from "./Footer";

interface LandingLayoutProps {
  children: ReactNode;
}

export function LandingLayout({ children }: LandingLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-[radial-gradient(circle_at_top,_rgba(72,118,255,0.12),transparent_55%)] bg-background">
      {/* Global Navigation */}
      <AppHeader />

      {/* Main content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
